import { render, staticRenderFns } from "./Packageconfiguration.vue?vue&type=template&id=984526b4"
import script from "./Packageconfiguration.vue?vue&type=script&lang=js"
export * from "./Packageconfiguration.vue?vue&type=script&lang=js"
import style0 from "./Packageconfiguration.vue?vue&type=style&index=0&id=984526b4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports